import React from 'react';
import { withStyles } from '@material-ui/core';
import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3, 0),
    textAlign: 'center',
  },
  title: {
    color: '#555',
    fontSize: '2.5em',
    fontWeight: 500,
    lineHeight: 3,
    '& span': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  subtitle: {
    color: '#aaa',
    fontSize: '1.3em',
  },
});

class Preparing extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <img src={`${EVENT_IMG}/preparing@2x.png`} alt="" style={{ width: '400px' }} />
        {/* <Typography className={classes.title}>
          To be <span>updated</span>
        </Typography> */}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Preparing);
